import { type CreateOrUpdateAlbumModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<Pick<CreateOrUpdateAlbumModel, 'name'>>]: number
} = {
  name: 150,
}
